import type { CSSProperties, JSX } from 'react';

import type { MyPlanCardDto } from '../../lib/api/openingTasks';
import { buildPhases, fmtDMY, fmtWindow, phaseColor, phaseCounter } from './plan-model';

/**
 * Полосы фаз (как `PhaseStrip` в CRM): у каждой фазы — полоска по этапам (пройден / идёт / впереди), «N из M этапов»,
 * даты фазы и «сейчас: <этап>».
 */
export function PlanPhaseStrip({ card }: { card: Pick<MyPlanCardDto, 'phases' | 'stages' | 'supportUntil'> }): JSX.Element | null {
  const phases = buildPhases(card);
  if (phases.length === 0) return null;
  return (
    <section className="fk-op-card fk-op-phases" aria-label="Фазы открытия">
      {phases.map((p) => (
        <div key={p.code} className="fk-op-ph" data-current={!!p.current} style={{ '--ph': phaseColor(p.code) } as CSSProperties}>
          <div className="fk-op-ph-bar" aria-hidden="true">
            {p.stages.map((s) => (
              <span
                key={s.code}
                className="fk-op-ph-seg"
                data-state={s.state}
                title={`${s.label}${s.state === 'done' ? ' — пройден' : s.state === 'current' ? ' — идёт' : ''}`}
              />
            ))}
          </div>
          <div className="fk-op-ph-name">{p.label}</div>
          <div className="fk-op-ph-sub">{phaseCounter(p)}</div>
          <div className="fk-op-ph-sub">{p.code === 'support' && card.supportUntil ? `до ${fmtDMY(card.supportUntil)}` : fmtWindow(p.start, p.end)}</div>
          {p.current ? <div className="fk-op-ph-now">сейчас: {p.current.label}</div> : null}
        </div>
      ))}
    </section>
  );
}
